import Vue from 'vue'
import VueGtag from 'vue-gtag'
import store from './store'
import App from './App.vue'
import Canvas from './canvas'

function getUserId () {
  const { search } = window.location
  return search && search.match(/\?id=[a-zA-Z0-9-]+$/)
    ? search.substring(4).toUpperCase()
    : null
}

function debug () {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...arguments)
  }
}

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_TRACKING_ID },
  enabled: process.env.NODE_ENV !== 'development'
})

Vue.mixin({
  methods: {
    track: function (name, params) {
      debug(name, params)
      this.$gtag.event(name, params)
    }
  }
})

new Canvas({
  elem: '#canvas'
}).render()

new Vue({
  store,
  created () {
    const userId = getUserId()
    userId && this.$gtag.set({ 'user_id': userId })
  },
  render: h => h(App)
}).$mount('#app')
